import { render, staticRenderFns } from "./anthropometry.vue?vue&type=template&id=0f98d014&"
import script from "./anthropometry.js?vue&type=script&lang=js&"
export * from "./anthropometry.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports